<template>
    <div class="user-info">
        <h1 class="user-info__header" v-html="$t('Info.header')"></h1>
        <span class="user-info__subtitle" v-html="$t('Info.email')"></span>
        <span class="user-info__data"> {{ user.email }} </span>

        <span class="user-info__subtitle" v-html="$t('Info.company')"></span>
        <span class="user-info__data" v-if="user.organization"> {{ user.organization.name }} </span>
    </div>
</template>

<script>
    export default {
        props: {
            user: Object,
            currentOrder: Array,
            packages: Array
        }
    }
</script>

<style lang="scss" scoped>
    .user-info {
        display: flex;
        flex-direction: column;
        
        &__header {
          font-size: 2rem;
          margin: 0 0 24px 0;
        }

        &__subtitle {
            font-size: 1.6rem;
            font-family: PlusJakartaSans-Bold, sans-serif;
            margin: 0 0 10px;
        }

        &__data {
            font-size: 1.6rem;
            margin: 0 0 10px;
        }
    }
</style>
